import React from 'react'
import Spinner from 'react-spinkit';


const BouncerLoader = () => {
  return (
    <div>
        <Spinner name="double-bounce" color="#FFD201" fadeIn="none" />
    </div>
  )
}

export default BouncerLoader